import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux'

import type { RootState, AppDispatch } from '../../app/store'
export const useAppDispatch = () => useReduxDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useReduxSelector
